const Svgator = {
    bound: new WeakSet(),

    init(selector = 'svg') {
        document.querySelectorAll(selector).forEach((svg) => {
            this.bind(svg)
        })
    },

    play(svg) {
        const player = svg.svgatorPlayer
        if (player && typeof player.play === 'function') {
            player.play()
            return true
        }
        return false
    },

    bind(svg) {
        if (!svg || this.bound.has(svg)) return
        this.bound.add(svg)

        const tryPlay = () => this.play(svg)

        if (!tryPlay()) {
            svg.addEventListener('ready', tryPlay)
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        tryPlay()
                    }
                })
            },
            { threshold: 0.2 }
        )

        observer.observe(svg)
    },
}

export default Svgator
